export function getErrorMessage(error: unknown, fallback = 'Erro desconhecido'): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  if (error && typeof error === 'object') {
    const obj = error as Record<string, unknown>
    const response = obj.response as Record<string, unknown> | undefined
    if (response) {
      const data = response.data as Record<string, unknown> | undefined
      if (data) {
        if (typeof data.message === 'string') return data.message
        if (typeof data.error === 'string') return data.error
        if (data.error && typeof data.error === 'object') {
          const errObj = data.error as Record<string, unknown>
          if (typeof errObj.message === 'string') return errObj.message
        }
      }
    }
    if (typeof obj.message === 'string') return obj.message
    if (typeof obj.error === 'string') return obj.error
  }
  return fallback
}

export function getErrorStatus(error: unknown): number | undefined {
  if (error && typeof error === 'object') {
    const obj = error as Record<string, unknown>
    const response = obj.response as Record<string, unknown> | undefined
    if (response && typeof response.status === 'number') return response.status
    if (typeof obj.status === 'number') return obj.status
  }
  return undefined
}

export function isErrorWithCode(error: unknown, code: string): boolean {
  if (error && typeof error === 'object') {
    const obj = error as Record<string, unknown>
    if (obj.code === code) return true
  }
  return false
}
